import { render, staticRenderFns } from "./WebApiSettingBody.vue?vue&type=template&id=1f38e745&"
import script from "./WebApiSettingBody.vue?vue&type=script&lang=ts&"
export * from "./WebApiSettingBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports